// shared/lib/renderApproverSign.js
import React from 'react';

export function renderApproverSign(state, signerBase64, styles) {
  switch (state) {
    case 1:
      return <span className={styles.signImage}>결재 대기</span>;

    case 2:
      return <span className={styles.signImage}>결재중</span>;

    case 3:
      return (
        <div className={styles.signImage}>
          <img src={signerBase64 || undefined} width={38} height={38} alt="결재자 서명" />
        </div>
      );

    case 4:
      return <span className={styles.signImage}>반려</span>;

    case 7:
      return (
        <div className={styles.signImage}>
          <img src={signerBase64 || undefined} width={38} height={38} alt="결재자 서명" />
        </div>
      );

    default:
      return <span>-</span>;
  }
}
